import { render } from "./Alert.vue?vue&type=template&id=b73d301c&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=b73d301c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b73d301c"

export default script